<template>
  <div class="col s12">
    <p></p>
    <div class="col s12 m12 l9" id="middle" >
      <div id='puzzleBoard' style="width: auto; height: auto;" :class="classboard"></div>
    </div>    
    <div class="col s12 m12 l3" style="text-align: center; padding-left: 20px;" v-if="puzzle.createby">
      <div class="">
        <blockquote><h6 v-if="puzzle.type === 'Practica'" id='eval' class="flat-text-header hello" style="text-align: center"></h6></blockquote>
        <div id="pgnComment" style="display: none;"></div>
        <!-- <h5 class="flat-text-header">{{ $t("puzzles.createBy") }} </h5>
        {{puzzle.createby}}
        <h5 class="flat-text-header">{{ $t("puzzles.date") }}</h5>
        {{puzzle.created | moment 'DD/MM/YYYY, h:mm:ss a'}}-->
        <h5 class="flat-text-header">{{ $t("puzzles.played") }}: {{ $t("puzzles.color." + turn) }}</h5>
        <div v-if="puzzle.type !== 'Practica'">
          <h6 class="flat-text-header">{{ $t("puzzles.movs") }}</h6>
          <blockquote class="chip pulse">{{numMoves}}</blockquote>
        </div>
        <!-- <h6 class="flat-text-header">Tiempo</h6>-->
        <blockquote class="chip pulse purple darken-4" style="text-align: center; font-size: small;overflow: hidden; text-overflow:ellipsis;color:white">
                <span class="" style="text-align: center;">Faltan <b>{{ times | timeBoard}}</b> de {{timeMove | timeBoard }}</span>
        </blockquote>
        <div v-if="mate && numMoves===0 && puzzle.type !== 'Practica'" style="text-align: center;">
          <span>
            <h3>{{ $t("puzzles.wins") }}</h3>      
          </span>
          <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" @click="nextPuzzle()">
            Siguiente
          </a>
        </div>
        <div v-else>
          <span>
            <h3>{{ resultPractica }}</h3>      
          </span>
          <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" @click="nextPuzzle()">
            Siguiente
          </a>
        </div>
        <div v-if="!mate && numMoves===0 && puzzle.type !== 'Practica'">
          <h3>{{ $t("puzzles.lost") }}</h3>
          <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4"
             @click="reintent()"
          >
            {{ $t("puzzles.reintent") }}
          </a>
        </div>
        <div slot="actions" v-if="puzzle.type !== 'Practica'">
          Difultad:  <blockquote class="chip pulse">{{ 100 - Math.round(puzzle.corrects * 100 / puzzle.intents) }}%</blockquote>
          <!-- <blockquote class="chip pulse"><span>Aciertos ({{puzzle.corrects}})</span></blockquote>
          <blockquote class="chip pulse"><span>Intentos ({{puzzle.intents}})</span></blockquote>-->
        </div>
         
        <div v-if="numMoves !== 0 && puzzle.type !== 'Practica'">
          <div class="row">
            <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" @click="pista()">pista</a>
          </div>
          <div class="row">
            <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" @click="resultado()">resultado</a>
          </div>
        </div>
  </div>
</div>
</div>
</template>


<script>
// import Chessground from 'chessground'
import Chess from 'chess.js'
import toast from 'vue-material-components'
// import Garbochess from '../../services/garbochess.min.js'
import EngineGame from '../../services/enginegame.js'
import PuzzleService from '../../services/puzzle'
import Store from '../../services/lstorage'
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
window.pgnBoardBase = 0
var timesColor = 0

export default {
  name: 'puzzleChess',
  props: {
    puzzle: {
      type: Object
    },
    classboard: {
      type: String
    },
    titlefen: {
      type: String
    },
    nextPuzzle: {
      type: Function,
      required: false,
      'default': function () {
        return false
      }
    }
  },
  data () {
    return {
      mate: false,
      numMoves: 1000,
      timeMove: 120,
      handMoves: 0,
      userColor: 'white',
      ground: 1,
      turn: 'white',
      stockfish: this.ChessEngine(), // EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'}),
      chess: new Chess(),
      chessPgn: new Chess(),
      stylesBoard: stylesBoard,
      times: 120,
      resultPractica: '',
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        })
    }
  },
  mixins: [
    toast
  ],
  methods: {
    ChessEngine () {
      // window.alert('Arrancando motor de evaluación')
      return EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'})
    },
    onResize (event) {
      document.body.dispatchEvent(new window.Event('chessground.resize'))
    },
    chessToDests (chess) {
      var dests = {}
      chess.SQUARES.forEach(function (s) {
        var ms = chess.moves({square: s, verbose: true})
        if (ms.length) dests[s] = ms.map(function (m) { return m.to })
      })
      return dests
    },
    resolvePuzzle (parms) {
      PuzzleService.resolve(this, parms).then(function (response) {
        // window.alert('bien')
      }, function (response) {
        // window.alert('mal')
      })
    },
    chessToColor (chess) {
      var t = chess.turn()
      var turn = (t === 'w') ? 'white' : 'black'
      this.turn = turn
      return turn
    },
    countDown () {
      if (isNaN(this.timeMove) === false) {
        this.times = this.timeMove
      } else {
        this.times = 120
      }
      clearInterval(timesColor)
      timesColor = setInterval(function () {
        this.times = this.times - 1
        if (this.times <= 0) {
          clearInterval(timesColor)
          this.times = 0
          this.onMove(-1, -1)
          this.mate = false
          this.numMoves = 0
        }
      }.bind(this), 1000)
    },
    pistaNext () {
      this.puzzle.startPlay = 1
      var moves = window.pgnBoardBase.getPgn().getMoves()
      // window.alert(this.puzzle.feninit)
      for (var i = 0; i < moves.length; i++) {
        var fen = moves[i].fen
        if (fen === this.puzzle.feninit) {
          // window.alert(this.puzzle.startPlay)
          break
        }
        this.puzzle.startPlay++
      }
      if (this.puzzle.startPlay > moves.length) {
        this.puzzle.startPlay = 0
      }
      if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0) {
        var numGetMove = this.puzzle.startPlay + this.handMoves
        // window.alert(this.puzzle.startPlay + this.handMoves)
        // window.alert('.' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation + '.')
        if (window.pgnBoardBase.getPgn().getMove(numGetMove) !== undefined) {
          this.ground.setAutoShapes({
            orig: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
            // dest: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
            brush: 'green',
            modifiers: {lineWidth: 10}
          })
        }
      }
    },
    resultadoNext () {
      this.countDown()
      this.puzzle.startPlay = 1
      var moves = window.pgnBoardBase.getPgn().getMoves()
      // window.alert(this.puzzle.feninit)
      for (var i = 0; i < moves.length; i++) {
        var fen = moves[i].fen
        if (fen === this.puzzle.feninit) {
          // window.alert(this.puzzle.startPlay)
          break
        }
        this.puzzle.startPlay++
      }
      if (this.puzzle.startPlay > moves.length) {
        this.puzzle.startPlay = 0
      }
      if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0) {
        var numGetMove = this.puzzle.startPlay + this.handMoves
        // window.alert(this.puzzle.startPlay + this.handMoves)
        // window.alert('.' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation + '.')
        this.onMove(window.pgnBoardBase.getPgn().getMove(numGetMove).from, window.pgnBoardBase.getPgn().getMove(numGetMove).from)
        if (window.pgnBoardBase.getPgn().getMove(numGetMove) !== undefined) {
          this.ground.setAutoShapes({
            orig: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
            dest: window.pgnBoardBase.getPgn().getMove(numGetMove).to,
            brush: 'yellow',
            modifiers: {lineWidth: 10}
          })
        }
      }
    },
    onMoveFinal (orig, dest, promopiece) {
      // window.swal('pieza' + JSON.stringify(promopiece))
      // window.swal('move')
      this.ground.setAutoShapes({
        orig: '-1',
        dest: '-1',
        brush: 'yellow',
        modifiers: {lineWidth: 10}
      })
      this.numMoves --
      this.chess.move({
        from: orig,
        to: dest,
        promotion: promopiece
      })
      this.ground.move(orig, dest)
      this.ground.set({
        fen: this.chess.fen(),
        turnColor: this.chessToColor(this.chess),
        movable: {
          color: this.chessToColor(this.chess),
          dests: this.chessToDests(this.chess)
        },
        animation: {
          enabled: true,
          duration: 600
        },
        highlight: {
          lastMove: true,       // add last-move class to squares
          check: true          // add check class to squares
        },
        drawable: {
          enabled: true,
          visible: true
        }
      })
      this.puzzle.startPlay = 1
      var moves = window.pgnBoardBase.getPgn().getMoves()
      // window.alert(JSON.stringify(moves))
      for (var i = 0; i < moves.length; i++) {
        var fen = moves[i].fen
        if (this.puzzle.feninit !== undefined && fen === this.puzzle.feninit) {
          // window.alert(this.puzzle.startPlay)
          break
        }
        this.puzzle.startPlay++
      }
      if (this.puzzle.startPlay > moves.length) {
        this.puzzle.startPlay = 0
      }
      if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0 && this.puzzle.type !== 'Practica') {
        var numGetMove = this.puzzle.startPlay + this.handMoves
        // window.alert(JSON.stringify(window.pgnBoardBase.getPgn().getMove(numGetMove)))
        // window.alert(this.handMoves)
        // window.alert('.' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation + '.')
        var equal = this.chess.history()[this.handMoves] === window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation
        if (equal === false) {
          for (var v = 0; v < window.pgnBoardBase.getPgn().getMove(numGetMove).variations.length; v++) {
            equal = this.chess.history()[this.handMoves] === window.pgnBoardBase.getPgn().getMove(numGetMove).variations[v].notation.notation
            if (equal === true) {
              // window.alert('variante ' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).variations[v].notation.notation + '.')
              break
            }
          }
        }
        if (equal === false /* this.chess.history()[this.handMoves] !== window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation*/) {
          // window.alert('pierdes')
          this.numMoves = 0
          this.mate = false
          // this.ground.stop()
          this.resolvePuzzle({_id: this.puzzle._id, resolve: this.mate ? 1 : 0})
          clearInterval(timesColor)
        } else if (this.numMoves <= 0) {
          // window.alert('ganas')
          this.mate = equal// this.chess.history()[this.handMoves] === window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation
          // this.ground.stop()
          this.resolvePuzzle({_id: this.puzzle._id, resolve: this.mate ? 1 : 0})
          this.loadPuzzle(this.chess.fen(), false)
          clearInterval(timesColor)
        } else {
          // this.movePC(this.turn)
          orig = window.pgnBoardBase.getPgn().getMove(numGetMove + 1).from
          dest = window.pgnBoardBase.getPgn().getMove(numGetMove + 1).to
          // this.onMove(sfrom, sto)
          this.numMoves --
          this.chess.move({
            from: orig,
            to: dest,
            promotion: promopiece
          })
          this.ground.move(orig, dest)
          this.ground.set({
            fen: this.chess.fen(),
            turnColor: this.chessToColor(this.chess),
            movable: {
              color: this.chessToColor(this.chess),
              dests: this.chessToDests(this.chess)
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            animation: {
              enabled: true,
              duration: 600
            },
            drawable: {
              enabled: true,
              visible: true
            }
          })
          this.loadPuzzle(this.chess.fen(), false)
          this.handMoves++
        }
      } else {
        this.resultPractica = ''
        this.movePC(this.turn)
        this.numMoves = 1
        if (this.isFinish(this.chess)) {
          clearInterval(timesColor)
          if (this.chess.in_checkmate()) {
            this.resultPractica = 'Jaque mate'
            this.toast('Jaque mate', 2000)
            this.mate = this.chess.turn() === this.turn
          } else if (this.chess.in_draw()) {
            this.toast('Tablas', 2000)
            this.resultPractica = 'Tablas'
          } else {
            this.mate = true
          }
          this.numMoves = 0
        }
        /* if (this.numMoves <= 0) {
          if (true * this.puzzle.type === 'Tactic' || this.puzzle.type === 'Aperturas' || this.puzzle.type === 'Finales' || this.puzzle.type === 'Estrategia'*) {
            // verificar que fen actual es la esperada
            // console.log(this.puzzle.fenfinish, this.ground.getFen())
            // window.alert(this.ground.getFen() + '\n' + this.puzzle.fenfinish.split(' ')[0])
            this.mate = this.puzzle.fenfinish.split(' ')[0] === this.ground.getFen()
          } else {
            this.mate = this.isFinish(this.chess)
          }
          this.ground.stop()
          this.resolvePuzzle({_id: this.puzzle._id, resolve: this.mate ? 1 : 0})
        } else {
          /* var PgnNew = this.puzzle.pgn.split('"]').join('"]\n')
          PgnNew = PgnNew.split('{}').join('')
          // window.alert(PgnNew)
          this.chessPgn.load_pgn(PgnNew)
          // window.alert(this.chessPgn.moves())
          // window.alert(this.chess.history()) *
          this.movePC(this.turn)
          if (this.isFinish(this.chess)) {
            // window.alert('this.isFinish')
          }
        } */
      }
      this.handMoves++
    },
    onMove (orig, dest) {
      // window.alert('onMove')
      let _self = this
      if (this.chess) {
        let turn = this.chess.turn() === 'w' ? 'white' : 'black'
        let piece
        if (_self.chess && _self.chess.get(orig)) {
          piece = _self.chess.get(orig).type
        }
        if (turn === _self.userColor && piece === 'p' && ((dest.substring(1, 2) === '8') || (dest.substring(1, 2) === '1'))) {
          window.swal('¿A que pieza promociona?', {
            buttons: {
              queen: {text: '♕', value: 'q'},
              rook: {text: '♖', value: 'r'},
              bishop: {text: '♝', value: 'b'},
              knight: {text: '♞', value: 'n'}
            }
          }).then(function (result) {
            setTimeout(() => {
              _self.onMoveFinal(orig, dest, result)
            }, 500)
          })
        } else {
          setTimeout(() => {
            this.onMoveFinal(orig, dest, 'q')
          }, 500)
        }
      } else {
        setTimeout(() => {
          this.onMoveFinal(orig, dest, 'q')
        }, 500)
      }
    },
    /* PcIngeniesMove (move) {
      var from = move & 0xFF
      var to = (move >> 8) & 0xFF
      var sfrom = Garbochess.FormatSquare(from)
      var sto = Garbochess.FormatSquare(to)
      this.onMove(sfrom, sto)
    },*/
    PcIngeniesMoveStockfish (move) {
      var from = move.from
      var to = move.to
      // window.alert(from)
      this.onMove(from, to)
    },
    movePC (turn) {
      if (turn !== this.userColor) {
        setTimeout(function () {
          this.pcMove(this.chess.fen())
        }.bind(this), 200)
      }
    },
    pcMove (fen) {
      if (this.stockfish !== null && this.stockfish !== undefined) {
        this.stockfish.setPlayerColor(this.orientation)
        // var white = parseFloat(this.time.white) * 1000
        // var black = parseFloat(this.time.black) * 1000
        // var incremento = parseFloat(this.time.incremento) * 1000
        // this.stockfish.setTime(1000, 0)
        this.stockfish.setDepth(10)
        this.stockfish.setNodes(0)
        // this.toast('<span>Deja que piense</span>', 1000)
        this.stockfish.prepareMove(fen, '', this.PcIngeniesMoveStockfish, 1000, 1000, 0, 0)
        /* if (this.puzzle._id) {
          // use chess moves
          // this.makeRandomMove()
          Garbochess.InitializeFromFen(fen)
          Garbochess.Search(this.PcIngeniesMove, 5, null)
        } else {
          // use garbochess ingenie (dando problemas con los flags)
          Garbochess.InitializeFromFen(fen)
          Garbochess.Search(this.PcIngeniesMove, 5, null)
        }*/
      }
    },
    makeRandomMove () {
      // window.alert('makeRandomMove')
      var possibleMoves = this.chess.moves({
        verbose: true
      })
      var randomIndex = Math.floor(Math.random() * possibleMoves.length)
      var move = possibleMoves[randomIndex]
      var from = move.from
      var to = move.to
      this.onMove(from, to)
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') */ && linea[0] !== '*') {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    loadPuzzle (fen, init) {
      // window.alert('loadpuzzle')
      try {
        if (init === true) {
          if (this.puzzle.timemove === undefined) {
            this.puzzle.timemove = 120
          }
          if (this.puzzle.nummoves === undefined) {
            this.puzzle.nummoves = 1
          }
          this.numMoves = parseInt(this.puzzle.nummoves) // (parseInt(this.puzzle.nummoves) * 2) - 1
          this.timeMove = parseInt(this.puzzle.timemove) // (parseInt(this.puzzle.nummoves) * 2) - 1
          // window.alert(this.puzzle.titlefen)
          this.titlefen = this.puzzle.titlefen
          this.handMoves = 0
        }
        if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0) {
          var Width = 500
          if (document.getElementById('puzzleBoard') !== undefined) {
            Width = document.getElementById('puzzleBoard').clientWidth
          }
          var pgnBoard = 0
          var pos = 'end'
          var start = fen !== undefined ? fen : ''
          if (init === true) {
            this.puzzle.pgn = this.puzzle.pgn.split('"]').join('"]\n')
            this.puzzle.pgn = this.puzzle.pgn.split('{}').join('')
          }
          var headers = this.parse_pgn_header(this.puzzle.pgn)
          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
            pos = fen !== undefined ? fen : 'end'
            if (!this.hasBody(this.puzzle.pgn)) {
              start = ''
              pos = headers['FEN']
            }
            if (pos === headers['FEN']) {
              start = ''
            }
          }
          if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
            start = ''
            pos = fen
          }
          if (fen === headers['FEN']) {
            pos = headers['FEN']
          }
          // window.alert(start + headers['FEN'])
          if (document.getElementById('pgnComment')) {
            document.getElementById('pgnComment').textContent = ''
          }
          // var winWidth = Math.min(window.innerWidth, window.outerWidth)
          pgnBoard = window.pgnEdit({inner: 'puzzleBoard', comment: 'pgnComment'}, {pgn: this.puzzle.pgn, position: pos, startPlay: start, width: Width, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: true, headers: true})
          this.ground = pgnBoard.board
          if (init === true) {
            this.chess = pgnBoard.chess
          }
          window.pgnBoardBase = pgnBoard.boardBase
          if (document.getElementById('puzzleBoard') !== undefined) {
            document.getElementById('puzzleBoard').style.height = Width + 'px'
            document.getElementById('puzzleBoard').style.width = Width + 'px'
          }
          // window.alert(this.userColor)
          if (init === true) {
            this.userColor = this.chess.turn() === 'w' ? 'white' : 'black'
            this.orientation = this.userColor
          }
          var options = {
            orientation: this.orientation,
            movable: {
              free: false,
              color: 'both',
              dests: this.chessToDests(this.chess),
              dropOff: 'revert',
              showDests: true,
              events: {
                after: this.onMove
              }
            },
            animation: {
              enabled: true,
              duration: 600
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            drawable: {
              enabled: false,
              visible: false
            }
          }
          // window.alert(pgnBoard.boardBase.getPgn().write_pgn())
          // window.alert(JSON.stringify(pgnBoard.boardBase.getPgn().getMove(0)))
          this.ground.set(options)
          this.chessToColor(this.chess)
          // this.movePC(this.turn)
        } else {
          if (fen) {
            this.chess.load(fen/* + ' ' + 'w KQ - 21 20'*/)
          } else {
            this.chess.load('8/2k5/8/8/6P1/8/8/4K3 w - - 0 1')
          }
          this.ground.set({
            fen: this.chess.fen(),
            turnColor: this.chessToColor(this.chess),
            movable: {
              color: this.chessToColor(this.chess),
              dests: this.chessToDests(this.chess)
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            drawable: {
              enabled: true,
              visible: true
            }
          })
          this.userColor = this.chess.turn() === 'w' ? 'white' : 'black'
          this.movePC(this.turn)
        }
        this.countDown()
        const comments = document.querySelectorAll('.afterComment')
        comments.forEach((comment) => {
          // Verifica si el texto del comentario contiene el emoji 🎥
          const textResource = comment.textContent.toLowerCase()
          if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
            // Añade la clase .highlight-move al elemento padre con clase .move
            comment.closest('.move').classList.add('highlight-move')
          }
        })
      } catch (error) {
        // this.toast('<span>' + 'Error LoadPuzzle: ' + error + '</span>', 3000)
        console.error('<span>' + 'Error LoadPuzzle: ' + error + '</span>', 3000)
      }
    },
    resultado () {
      this.resultadoNext()
    },
    pista () {
      this.pistaNext()
    },
    isFinish (chess) {
      // clearInterval(timesColor)
      return chess.game_over()
    },
    reintent () {
      clearInterval(timesColor)
      this.mate = false
      this.loadPuzzle(this.puzzle.feninit, true)
    }
  },
  beforeDestroy () {
    if (this.stockfish !== null && this.stockfish !== undefined) {
      // window.alert('Parando motor de evaluación')
      this.stockfish.close()
      this.stockfish = null
    }
  },
  ready () {
    // window.alert('READY')
    try {
      // Garbochess.ResetGame()
      // this.stockfish = EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'})
      // var baseTime = 1 * 60
      // var inc = 1
      // var level = (parseFloat(this.board.elo) / 100) - 4
      // window.alert('Nivel ' + level)
      var skill = 20 // 0 600 --> 10 1600 --> 20 --> 2600
      // window.alert(this.stockfish)
      this.stockfish = EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'})
      // window.alert(this.stockfish)
      if (this.stockfish !== null && this.stockfish !== undefined) {
        this.stockfish.reset()
        // this.stockfish.setTime(parseFloat(this.time.white), this.time.incremento)
        this.stockfish.setSkillLevel(skill)
        this.stockfish.setPlayerColor(this.orientation)
        this.stockfish.setDisplayScore(true)
        this.stockfish.setOwnBook(false)
        this.stockfish.start()
      }
      window.addEventListener('resize', this.onResize)
      // window.alert(classBoard)
      setTimeout(function () {
        // this.ground = Chessground(document.getElementById('puzzleBoard'), options)
        var pgnBoard = 0
        // window.alert(this.pgn)
        // var PgnNew = this.puzzle.pgn.split('"]').join('"]\n')
        // PgnNew = PgnNew.split('{}').join('')
        // window.alert(PgnNew)
        if (document.getElementById('pgnComment')) {
          document.getElementById('pgnComment').textContent = ''
        }
        // var winWidth = Math.min(window.innerWidth, window.outerWidth)
        pgnBoard = window.pgnEdit({inner: 'puzzleBoard', comment: 'pgnComment'}, {showCoords: true, width: Width, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: true, headers: true})
        if (pgnBoard.board !== undefined && pgnBoard.board !== null) {
          this.ground = pgnBoard.board
          window.pgnBoardBase = pgnBoard.boardBase
          // window.alert(pgnBoard.chess.color())
          var options = {
            orientation: 'white',
            movable: {
              free: false,
              color: 'both',
              dests: this.chessToDests(this.chess),
              dropOff: 'revert',
              showDests: true,
              events: {
                after: this.onMove
              }
            },
            animation: {
              enabled: true,
              duration: 600
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            drawable: {
              enabled: true,
              visible: true
            }
          }
          this.ground.set(options)
          if (document.getElementById('puzzleBoard')) {
            var Width = document.getElementById('puzzleBoard').clientWidth - 20
            if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
              Width = Width - 35
            }
            document.getElementById('puzzleBoard').style.height = Width + 'px'
            document.getElementById('puzzleBoard').style.width = Width + 'px'
          }
          // getFromLocalStorage
          // console.log('cargando board')
          this.loadPuzzle('', true)
        }
        const comments = document.querySelectorAll('.afterComment')
        comments.forEach((comment) => {
          // Verifica si el texto del comentario contiene el emoji 🎥
          const textResource = comment.textContent.toLowerCase()
          if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
            // Añade la clase .highlight-move al elemento padre con clase .move
            comment.closest('.move').classList.add('highlight-move')
          }
        })
      }.bind(this), 10)
    } catch (error) {
      // this.toast('<span>' + 'Error (ready puzzle): ' + error + '</span>', 3000)
      console.error('<span>' + 'Error (ready puzzle): ' + error + '</span>', 3000)
    }
  },
  watch: {
    puzzle (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.loadPuzzle(newVal.feninit, true)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../static/libs/simplechessboard.min.css';
h1 {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// puzzle.vue?cec7421e